import * as components from './components'
import * as hooks from './hooks'

console.log('Shipping methods feature initialized!')

export { components, hooks }
